module.exports = __webpack_public_path__ + "static/img/bg_xskt_top@2x.65890d53.png";